export function DetailField ({ label, children, wide = false }) {
  return (
    <div className={`security-detail-field${wide ? ' security-detail-field-wide' : ''}`}>
      <span>{label}</span>
      <div>{children}</div>
    </div>
  )
}